import { z } from "zod";

export const schemeSchema = z.object({
  id: z.number(),
  scheme_code: z.string(),
  scheme_name: z.string(),
  scheme_isin: z.string(),
  scheme_type: z.string(),
  // Backend is not sending these fields reliably
  fund_scheme_id: z.number().nullable().optional(),
  amc_id: z.number().nullable(),
  amc_name: z.string().nullable(),
  amc_morningstar_code: z.string().nullable(),
});

export const oneTimeSchemeSchema = schemeSchema.merge(
  z
    .object({
      active: z.boolean().nullable(),
      additional_purchase_max_amount: z.string().nullable(),
      additional_purchase_min_amount: z.number().nullable(),
      div_reinvest_flag: z.string().nullable(),
      exit_load: z.string().nullable(),
      exit_load_flag: z.boolean().nullable(),
      investment_option: z.string().nullable(),
      new_purchase_min_amount: z.number().nullable(),
      purchase_allowed: z.boolean().nullable(),
      purchase_amount_multiplier: z.string().nullable(),
      redemption_allowed: z.boolean().nullable(),
      redemption_amount_multiplier: z.string().nullable(),
      redemption_max_amount: z.string().nullable(),
      redemption_max_quantity: z.number().nullable(),
      redemption_min_amount: z.string().nullable(),
      redemption_min_quantity: z.number().nullable(),
      redemption_units_multiplier: z.string().nullable(),
      rta_scheme_code: z.string().nullable(),
      sip_allowed: z.boolean().nullable(),
      stp_allowed: z.boolean().nullable(),
    })
    .passthrough()
);

export const sipSchemeSchema = schemeSchema.merge(
  z
    .object({
      dates: z.array(z.number()).nullable(),
      frequency: z.string().nullable(),
      maximum_installment_amount: z.string().nullable(),
      maximum_installment_numbers: z.number().nullable(),
      minimum_installment_amount: z.string().nullable(),
      minimum_installment_numbers: z.number().nullable(),
      multiplier_amount: z.string().nullable(),
      status: z.string().nullable(),
      transaction_mode: z.string().nullable(),
    })
    .passthrough()
);

export const stpSchemeSchema = schemeSchema.merge(
  z
    .object({
      frequency: z.string().nullable(),
      in_maximum_installment_amount: z.number().nullable(),
      in_minimum_installment_amount: z.number().nullable(),
      in_multiplier_amount: z.string().nullable(),
      maximum_installment_numbers: z.number().nullable(),
      maximum_installment_units: z.string().nullable(),
      minimum_installment_numbers: z.number().nullable(),
      minimum_installment_units: z.string().nullable(),
      multiplier_units: z.string().nullable(),
      out_maximum_installment_amount: z.number().nullable(),
      out_minimum_installment_amount: z.number().nullable(),
      out_multiplier_amount: z.string().nullable(),
      status: z.string().nullable(),
      transaction_mode: z.string().nullable(),
      dates: z.array(z.number()).nullable(),
    })
    .passthrough()
);

export const swpSchemeSchema = schemeSchema.merge(
  z
    .object({
      transaction_mode: z.string().nullable(),
      frequency: z.string().nullable(),
      dates: z.array(z.number()).nullable(),
      minimum_gap: z.number().nullable(),
      maximum_gap: z.number().nullable(),
      installment_gap: z.number().nullable(),
      status: z.string().nullable(),
      minimum_installment_amount: z.string().nullable(),
      maximum_installment_amount: z.string().nullable(),
      multiplier_amount: z.string().nullable(),
      multiplier_units: z.string().nullable(),
      minimum_installment_numbers: z.number().nullable(),
      maximum_installment_numbers: z.number().nullable(),
      scheme_type: z.string().nullable(),
    })
    .passthrough()
);
